module.exports = __webpack_public_path__ + "static/media/CARD.bd764233.svg";